import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { AccordionCohabitationVM } from 'cohabitation/view-models/detail-cohabitation';
import { FormikErrors, FormikTouched } from 'formik';

interface FormCohabitatonProps {
  disabled?: boolean;
  values?: AccordionCohabitationVM;
  isEditMode?: boolean;
  onChange: (
    key: keyof AccordionCohabitationVM,
    value: AccordionCohabitationVM[keyof AccordionCohabitationVM]
  ) => void;
  errors?: FormikErrors<AccordionCohabitationVM>;
  touched?: FormikTouched<AccordionCohabitationVM>;
}

const FormCohabitatonComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: FormCohabitatonProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Identificativo Comune"
            label="Identificativo Comune"
            id="municipalityIdentifier"
            name="municipalityIdentifier"
            fullWidth
            disabled={isEditMode ? false : disabled}
            type="text"
            onChange={(event) => {
              onChange('municipalityIdentifier', event.target.value);
            }}
            variant="outlined"
            value={values?.municipalityIdentifier || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Codice ISTAT"
            label="Codice ISTAT"
            id="istatCode"
            name="istatCode"
            fullWidth
            type="text"
            disabled={isEditMode ? false : disabled}
            onChange={(event) => {
              onChange('istatCode', event.target.value);
            }}
            variant="outlined"
            value={values?.istatCode || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Identificativo ANPR"
            label="Identificativo ANPR"
            id="idANPR"
            name="idANPR"
            fullWidth
            type="text"
            disabled
            onChange={(event) => {
              onChange('idANPR', event.target.value);
            }}
            variant="outlined"
            value={values?.idANPR || ''}
          />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <DatePicker
            label="Data origine"
            value={values?.originDate || null}
            disabled={isEditMode ? false : disabled}
            onChange={(dataValue) => {
              onChange('originDate', dataValue || null);
            }}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="originDate"
                fullWidth
                error={touched?.originDate && Boolean(errors?.originDate)}
                helperText={errors?.originDate}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Specie convivenza"
          label="Specie convivenza"
          id="kindCohabitation"
          name="kindCohabitation"
          disabled={isEditMode ? false : disabled}
          fullWidth
          type="text"
          onChange={(event) => {
            onChange('kindCohabitation', event.target.value);
          }}
          variant="outlined"
          value={values?.kindCohabitation || ''}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Denominazione convivenza"
          label="Denominazione convivenza"
          id="nameCohabitation"
          name="nameCohabitation"
          disabled={isEditMode ? false : disabled}
          fullWidth
          type="text"
          onChange={(event) => {
            onChange('nameCohabitation', event.target.value);
          }}
          error={touched?.nameCohabitation && Boolean(errors?.nameCohabitation)}
          helperText={errors?.nameCohabitation}
          variant="outlined"
          value={values?.nameCohabitation || ''}
        />
      </Grid>
    </Grid>
  );
};

FormCohabitatonComponent.displayName = 'Form cohabitation insert component';

const FormCohabitaton = memo(FormCohabitatonComponent);

export default FormCohabitaton;
